import { useRef } from "react"
import { toPng } from "html-to-image"

const useRenderElement = () => {
    const ref = useRef(null)

    const handleExport = async () => {
        if (ref.current) {
            try {                
                return toPng(ref.current, { cacheBust: true })
            } catch (error) {
                console.error("Could not generate image", error)
                return undefined
            }
        }
    }

    return {
        handleExport,
        ref,
    }
}

export default useRenderElement
